import React, { SetStateAction, Dispatch, useState, Fragment, FormEvent } from 'react';

import { X } from 'lucide-react';

import { TextInput } from '../../../shared/Inputs';

import { useCreateConsent } from '../../../../hooks/mbts_consents';

interface ConsentDataGatherProps {
    isVisible: boolean;
    setIsVisible: Dispatch<SetStateAction<boolean>>;
};

export const ConsentDataGather = (props: ConsentDataGatherProps) => {
    const { isVisible, setIsVisible } = props;

    const [consentEmail, setConsentEmail] = useState<string>('');
    const [consentName, setConsentName] = useState<string>('');
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);

    const { mutate: createConsent } = useCreateConsent();

    const onClose = () => {
        setIsVisible(false);
    };

    const gatherConsentData = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (isProcessing || !consentEmail || !consentName?.trim()?.length) return;

        createConsent({
            payload: {
                email: consentEmail,
                name: consentName,
            },
            setIsProcessing,
            setError,
            setIsSuccess,
        });
    };

    return (
        <div className={`mbts_analysis__consent_data_gather ${isVisible ? 'mbts_analysis__consent_data_gather--visible' : ''}`}>
            <div className='card card--md card--radius-md mbts_analysis__consent_data_gather__content'>
                {isSuccess && (
                    <Fragment>
                        <p className="text-lg text-semibold color--success text-center">Thank you for submitting your email address!</p>
                        <p className="color--txt-muted text-center mb-2xl">You can now close this window.</p>
                        <button className="btn btn--fluid btn--md btn--radius-md btn--primary" onClick={onClose}>Close</button>
                    </Fragment>
                )}
                {!isSuccess && (
                    <Fragment>
                        <button className="mbts_analysis__consent_data_gather__close" onClick={onClose}>
                            <X />
                        </button>
                        <p className="text-semibold text-lg text-center">Want to unlock full report?</p>
                        <p className="color--txt-muted text-center mb-2xl">Please provide your email address to unlock the report.</p>
                        <form onSubmit={gatherConsentData}>
                            <div className="mb-lg">
                                <TextInput
                                    type="text"
                                    placeholder="Your Name"
                                    value={consentName}
                                    onChange={e => setConsentName(e.target.value)}
                                />
                            </div>
                            <TextInput
                                type="email"
                                placeholder="Email address"
                                value={consentEmail}
                                onChange={e => setConsentEmail(e.target.value)}
                            />
                            <button
                                className="btn btn--fluid btn--md btn--radius-md btn--primary mt-xl"
                                type="submit"
                                disabled={isProcessing || !consentEmail || !consentName?.trim()?.length}
                            >
                                {isProcessing
                                    ? <span className='btn-loader' />
                                    : <span>Unlock Report</span>
                                }
                            </button>
                        </form>
                        {error && (
                            <p className="text-sm color--error text-center mt-xs">{error}</p>
                        )}
                    </Fragment>
                )}
            </div>
        </div>
    );
};
